"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Flex = _interopRequireDefault(require("../../../Flex"));

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _CalendarFrom = _interopRequireDefault(require("../../../Icons/CalendarFrom"));

var _useTheme2 = _interopRequireDefault(require("../../../styles/useTheme"));

var _EndDate = _interopRequireDefault(require("./EndDate"));

var _StartDate = _interopRequireDefault(require("./StartDate"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var useStyles = function useStyles() {
  var _useTheme = (0, _useTheme2["default"])(),
      spacing = _useTheme.spacing;

  return {
    root: {
      paddingLeft: spacing(4),
      alignItems: 'center'
    }
  };
};

__signature__(useStyles, "useTheme{{ spacing }}", function () {
  return [_useTheme2["default"]];
});

var JobPeriod = function JobPeriod(props) {
  var startDate = props.startDate,
      endDate = props.endDate,
      other = (0, _objectWithoutProperties2["default"])(props, ["startDate", "endDate"]);
  var classes = useStyles();
  return (0, _core.jsx)(_Flex["default"], (0, _extends2["default"])({
    css: classes.root
  }, other), (0, _core.jsx)(_Icon["default"], {
    as: _CalendarFrom["default"],
    margin: [-0.5, 1, 0, 0],
    size: 6,
    color: "icon"
  }), (0, _core.jsx)("div", null, (0, _core.jsx)(_StartDate["default"], {
    date: startDate
  }), endDate && (0, _core.jsx)(_EndDate["default"], {
    date: endDate
  })));
};

__signature__(JobPeriod, "useStyles{classes}", function () {
  return [useStyles];
});

var _default = JobPeriod;
var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(useStyles, "useStyles", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/JobPeriod.tsx");
  reactHotLoader.register(JobPeriod, "JobPeriod", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/JobPeriod.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/ResponsiveJobCard/Main/Dates/JobPeriod.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();